<template>
  <div>
    <vx-card class="mb-6">
      <infoTabela :dados="dados"></infoTabela>
    </vx-card>
    <vx-card>
      <ListTabelaEstadoCidades :dados="dados"></ListTabelaEstadoCidades>
    </vx-card>
  </div>
</template>

<script>
import service from "../../../services";
import infoTabela from "../../Includes/infoTabela";
import ListTabelaEstadoCidades from "./../../lists/ListTabelaEstadoCidades";
export default {
  data() {
    return {
      dados: { Tabelas_Grupo: {} },
      exibeCilindrada: false
    };
  },
  methods: {
    getDadosTabela() {
      this.$vs.loading();
      service
        .getAll("Tabela", {}, "listOne/" + this.$route.params.id)
        .then(res => {
          this.dados = res.data[0];
          this.$vs.loading.close();
        })
        .catch(e => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    }
  },
  mounted() {
    this.getDadosTabela();
  },
  components: {
    infoTabela,
    ListTabelaEstadoCidades
  }
};
</script>
